import { request } from "../../apis";

export const apiGetSkiResort = (): any =>
  request("get", `/api/skiresort/list`, null, true);
